import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { apiClient } from "../lib/api";
import { markBackendWarm } from "../lib/warmup";

const AuthContext = createContext(null);
const TOKEN_KEY = "pitchiq_token";

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await apiClient.get("/auth/me");
      markBackendWarm();
      setUser(data.user);
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = useCallback(async (email, password) => {
    const { data } = await apiClient.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const register = useCallback(async (email, password, name, username, favourite_team) => {
    const { data } = await apiClient.post("/auth/register", { email, password, name, username, favourite_team });
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(null);
  }, []);

  const setSession = useCallback((token, u) => {
    localStorage.setItem(TOKEN_KEY, token);
    setUser(u);
  }, []);

  const value = useMemo(
    () => ({ user, loading, login, register, logout, setSession, refresh: loadMe }),
    [user, loading, login, register, logout, setSession, loadMe]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
